import { render, staticRenderFns } from "./PromotionChart2.vue?vue&type=template&id=0401e0d5&scoped=true&"
import script from "./PromotionChart2.vue?vue&type=script&lang=js&"
export * from "./PromotionChart2.vue?vue&type=script&lang=js&"
import style0 from "./PromotionChart2.vue?vue&type=style&index=0&id=0401e0d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401e0d5",
  null
  
)

export default component.exports